import { API_URL } from '../../../../utils/config';

export const GET_ZONES_URL = `${API_URL}/zones`;
export const GET_ZOHO_URL = `${API_URL}/customercallLognew/fetchzohodepartments`;
export const CREATE_ZONE_URL = `${API_URL}/zones`;
export const CREATE_SUB_ZONE_URL = `${API_URL}/subzone`;
export const DELETE_ZONE_URL = `${API_URL}/zone`;
export const EDIT_ZONE_URL = `${API_URL}/zone`;
